import React, {useEffect} from "react";
import { Route, Routes } from "react-router-dom";
import Header from "../common/header/header";
import Footer from "../common/footer/footer";
import Dashboard from "../dashboard/dashboard";
import Sidebar from "../common/sidebar/sidebar";
import PaymentLogin from "../payment/login/login";
import PaymentDashboard from "../payment/dashboard/dashboard";
import PayNow from "../payment/pay/pay-now";
import PaymentHistory from "../payment/history/payment-history";
import PaymentReceipt from "../payment/paymentreceipt/paymentreceipt";
import AdmissionLetterLandingPage from "../authentication/test";
import LoginFromStaff from "../authentication/login-from-staff";

export default function PageRoutes() {

    return (<>
        <div className="main-wrapper">
            <Header/>
            <Sidebar/>
            <div className="page-wrapper">
                <div className="content">
                    <Routes>
                        {/* Dashboard Redirect */}
                        <Route exact path="/" element={<Dashboard />} />
                        <Route exact path="/dashboard" element={<Dashboard />} />
                        <Route path="/login-from-staff/:id" element={<LoginFromStaff/>}/>
                        <Route exact path="/login" element={<PaymentLogin />}/>
                        <Route exact path="/portal/payment/dashboard" element={<PaymentDashboard />}/>
                        <Route exact path="/portal/payment/pay-now" element={<PayNow />}/>
                        <Route exact path="/portal/payment/history" element={<PaymentHistory />}/>
                        <Route exact path="/portal/payment/payment-receipt/:slug" element={<PaymentReceipt />}/>
                        <Route exact path="/test" element={<AdmissionLetterLandingPage />}/>

                        <Route path="*" element={<></>} />
                    </Routes>
                    <Footer/>
                </div>

            </div>
        </div>
    </>)
}